exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardHeader-b4ed8{display:flex;align-items:center}.rangePicker-07ef6{width:200px}", ""]);

// Exports
exports.locals = {
	"dashboardHeader": "dashboardHeader-b4ed8",
	"rangePicker": "rangePicker-07ef6"
};